import React from "react";
import AccountantNavBar from "./AccountantNavBar";
import { closeMobileNav, useMetisMenu } from "./navMenu";
import {
  branch,
  is_shop_admin,
  is_shop_manager,
  is_superuser,
  is_franchise_admin,
  is_franchise_manager,
  is_franchise_staff,
  has_franchise_reach,
  is_accountant_only,
  franchise,
  works_in_franchise,
  runs_franchise,
  is_back_office,
} from "../Functionalities/Config";

function FullNavBar() {
  useMetisMenu();

  return (
    <div>
      <div className="deznav-backdrop" onClick={closeMobileNav} />
      <div className="deznav">
        <div className="deznav-scroll">
          <ul className="metismenu" id="menu">
            <li className="marginToClass">
              <a
                className="has-arrow ai-icon"
                href="javascript:void()"
                aria-expanded={"false"}
              >
                <i className="flaticon-381-networking" />
                <span className="nav-text">Home</span>
              </a>
              <ul aria-expanded={"false"} className={`mm-collapse`}>
                {(is_shop_manager ||
                  is_shop_admin ||
                  is_superuser ||
                  is_franchise_admin ||
                  is_franchise_manager) && (
                  <li>
                    <a href="/" onClick={closeMobileNav}>Dashboard</a>{" "}
                  </li>
                )}

                {is_superuser && (
                  <li>
                    <a href="/server-health" onClick={closeMobileNav}>Server health</a>
                  </li>
                )}

                {(is_superuser || has_franchise_reach) && (
                  <li>
                    <a href="/home-banners" onClick={closeMobileNav}>Home banners</a>
                  </li>
                )}

                {works_in_franchise && (
                  <li>
                    <a href="/notification" onClick={closeMobileNav}> Notification</a>{" "}
                  </li>
                )}
                {is_back_office && (
                  <li>
                    {" "}
                    <a href="/comments" onClick={closeMobileNav}>Reviews</a>{" "}
                  </li>
                )}

                {works_in_franchise && (
                  <li>
                    {" "}
                    <a href="/mobileLandingPage" onClick={closeMobileNav}>Mobile Landing Page</a>{" "}
                    <a href="/sections" onClick={closeMobileNav}>App Sections</a>{" "}
                  </li>
                )}
              </ul>
            </li>
            {
              <li
                className="marginToClass"
                onClick={() => {
                  sessionStorage.setItem("rejected", false);
                  sessionStorage.setItem("unattended", false);
                  closeMobileNav();
                }}
              >
                <a href="/orders" aria-expanded="false" onClick={closeMobileNav}>
                  {" "}
                  <i className="fa fa-first-order" />
                  <span className="nav-text">Orders</span>
                </a>
              </li>
            }

            {!is_shop_manager && (
              <li className="marginToClass">
                <a
                  className="has-arrow ai-icon"
                  href="javascript:void()"
                  aria-expanded="false"
                >
                  <i className="flaticon-381-user" />
                  <span className="nav-text">Users</span>
                </a>
                <ul aria-expanded="false" className="mm-collapse">
                  {works_in_franchise && (
                    <li>
                      {" "}
                      <a href="/delivery-boys" onClick={closeMobileNav}> Delivery Boys</a>
                    </li>
                  )}
                  {is_shop_admin && (
                    <li>
                      {" "}
                      <a href="/managers" onClick={closeMobileNav}> Managers</a>{" "}
                    </li>
                  )}
                  {(is_superuser ||
                    is_franchise_admin ||
                    is_franchise_manager) && (
                    <li>
                      {" "}
                      <a href="/customers" onClick={closeMobileNav}> Customers</a>{" "}
                    </li>
                  )}
                </ul>
              </li>
            )}

            <li className="marginToClass">
              <a
                className="has-arrow ai-icon"
                href="javascript:void()"
                aria-expanded="false"
              >
                <i className="fa fa-archive " />
                <span className="nav-text">
                  {is_shop_manager || is_shop_admin
                    ? "Restaurant"
                    : "Franchise"}{" "}
                </span>
              </a>
              <ul aria-expanded="false" className="mm-collapse">
                {is_superuser && (
                  <li>
                    <a href="/franchises" onClick={closeMobileNav}>Franchise</a>{" "}
                  </li>
                )}
                {(is_shop_manager || is_shop_admin) && (
                  <li>
                    <a href={"/restaurant/" + branch[0].id} onClick={closeMobileNav}> Details</a>{" "}
                  </li>
                )}
                {runs_franchise && (
                  <li>
                    <a href={"/franchise/" + franchise.id} onClick={closeMobileNav}> Details</a>{" "}
                  </li>
                )}
                {works_in_franchise && (
                  <li>
                    <a href="/restaurants" onClick={closeMobileNav}> Restaurants</a>{" "}
                  </li>
                )}
              </ul>
            </li>

            <li className="marginToClass">
              <a
                className="has-arrow ai-icon"
                href="javascript:void()"
                aria-expanded="false"
              >
                <i className="fa fa-star" />
                <span className="nav-text">Items And Menu</span>
              </a>
              <ul aria-expanded="false" className="mm-collapse">
                {(!is_superuser ||
                  works_in_franchise) && (
                  <li>
                    {" "}
                    <a href="/menu" onClick={closeMobileNav}>Menu</a>{" "}
                  </li>
                )}

                {(is_shop_manager ||
                  is_shop_admin ||
                  !is_superuser ||
                  works_in_franchise) && (
                  <li>
                    {" "}
                    <a href="/products" onClick={closeMobileNav}>Products</a>{" "}
                  </li>
                )}
                {(is_shop_manager ||
                  is_shop_admin ||
                  !is_superuser ||
                  works_in_franchise) && (
                  <li>
                    {" "}
                    <a href="/offer-products" onClick={closeMobileNav}>Offer Products</a>{" "}
                  </li>
                )}
                {(!is_superuser ||
                  works_in_franchise) && (
                  <li>
                    {" "}
                    <a href="/sloats" onClick={closeMobileNav}> Product Slots</a>{" "}
                  </li>
                )}
                {(is_superuser || has_franchise_reach) && (
                  <li>
                    {" "}
                    <a href="/delivery-slots" onClick={closeMobileNav}> Delivery Slots</a>{" "}
                  </li>
                )}
                {(is_superuser ||
                  is_franchise_admin ||
                  is_franchise_manager) && (
                  <li>
                    {" "}
                    <a href="/promocode" onClick={closeMobileNav}> Promo Code</a>{" "}
                  </li>
                )}
                {works_in_franchise && (
                  <li>
                    {" "}
                    <a href="/banners" onClick={closeMobileNav}> Banners</a>{" "}
                  </li>
                )}
              </ul>
            </li>

            {(is_superuser ||
              is_franchise_admin ||
              is_franchise_manager ||
              is_shop_admin ||
              is_shop_manager) && (
              <li className="marginToClass">
                <a
                  className="has-arrow ai-icon"
                  href="javascript:void()"
                  aria-expanded="false"
                >
                  <i className="fa fa-line-chart" />
                  <span className="nav-text">Insights</span>
                </a>
                <ul aria-expanded="false" className="mm-collapse">
                  <li>
                    <a href="/insights" onClick={closeMobileNav}>Overview</a>
                  </li>
                  {(is_superuser || is_franchise_admin || is_franchise_manager) && (
                    <li>
                      <a href="/restaurant-response" onClick={closeMobileNav}>Restaurant Response</a>
                    </li>
                  )}
                </ul>
              </li>
            )}
            {(is_superuser || is_franchise_admin || is_franchise_manager) && (
              <li className="marginToClass">
                <a
                  className="has-arrow ai-icon"
                  href="javascript:void()"
                  aria-expanded="false"
                >
                  <i className="flaticon-381-notepad" />
                  <span className="nav-text">Reports</span>
                </a>
                <ul aria-expanded="false" className="mm-collapse">
                  {is_superuser && (
                    <li>
                      <a href="/wallet-reports" onClick={closeMobileNav}>Wallet</a>
                    </li>
                  )}
                  {(is_superuser || (has_franchise_reach && !is_franchise_staff)) && (
                    <li>
                      <a href="/reports" onClick={closeMobileNav}>Orders Report</a>
                    </li>
                  )}
                  {(is_superuser || is_franchise_admin || is_franchise_manager) && (
                    <li>
                      <a href="/payouts" onClick={closeMobileNav}>Restaurant Payouts</a>
                    </li>
                  )}
                  {(is_superuser || is_franchise_admin || is_franchise_manager) && (
                    <li>
                      <a href="/restaurant-settlement" onClick={closeMobileNav}>Restaurant Settlement</a>
                    </li>
                  )}
                  {(is_superuser || is_franchise_admin || is_franchise_manager) && (
                    <li>
                      <a href="/rider-settlement" onClick={closeMobileNav}>Rider Salary</a>
                    </li>
                  )}
                  {(is_superuser || is_franchise_admin || is_franchise_manager) && (
                    <li>
                      <a href="/deliveryboy-reports" onClick={closeMobileNav}>Rider Collection</a>
                    </li>
                  )}
                  {is_superuser && (
                    <li>
                      <a href="/app-updates" onClick={closeMobileNav}>App updates</a>
                    </li>
                  )}
                </ul>
              </li>
            )}
            <li className="marginToClass">
              <a href="/settings" aria-expanded="false" onClick={closeMobileNav}>
                {" "}
                <i className="flaticon-381-settings-2" />
                <span className="nav-text">Settings</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

function NavBar() {
  return is_accountant_only ? <AccountantNavBar /> : <FullNavBar />;
}

export default NavBar;
